/**
 * Sticky header scroll state + mobile Offcanvas (close on navigate, Escape, aria sync).
 */
import Offcanvas from 'bootstrap/js/src/offcanvas.js';
import { initZkMobileNavCollapsible } from '../src/js/mobile-nav-collapsible.js';

export function initZkHeader() {
  const panel = document.getElementById('zkMainNav');

  if (panel) {
    initZkMobileNavCollapsible();
    const offcanvas = Offcanvas.getOrCreateInstance(panel);
    const toggle = document.querySelector('[data-bs-target="#zkMainNav"]');

    panel.querySelectorAll('a[href]').forEach((anchor) => {
      anchor.addEventListener('click', () => {
        if (!window.matchMedia('(max-width: 991.98px)').matches) {
          return;
        }
        if (!panel.classList.contains('show')) {
          return;
        }
        offcanvas.hide();
      });
    });

    panel.addEventListener('show.bs.offcanvas', () => {
      document.body.classList.add('zk-menu-open');
    });
    panel.addEventListener('shown.bs.offcanvas', () => {
      toggle?.setAttribute('aria-expanded', 'true');
    });
    panel.addEventListener('hidden.bs.offcanvas', () => {
      toggle?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('zk-menu-open');
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !panel.classList.contains('show')) {
        return;
      }
      offcanvas.hide();
    });
  }

}
